import { SVGProps } from 'react'

export function InstagramIcon({ ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      {...props}
    >
      <path
        d="M11.1654 4.33325H11.172M4.16536 1.33325H10.832C12.673 1.33325 14.1654 2.82564 14.1654 4.66659V11.3333C14.1654 13.1742 12.673 14.6666 10.832 14.6666H4.16536C2.32442 14.6666 0.832031 13.1742 0.832031 11.3333V4.66659C0.832031 2.82564 2.32442 1.33325 4.16536 1.33325ZM10.1655 7.57996C10.2478 8.13479 10.153 8.70143 9.89467 9.1993C9.63633 9.69717 9.22759 10.1009 8.72658 10.3531C8.22557 10.6052 7.65779 10.693 7.10402 10.6039C6.55025 10.5148 6.03867 10.2533 5.64205 9.85673C5.24544 9.46012 4.98398 8.94854 4.89487 8.39477C4.80576 7.84099 4.89354 7.27322 5.14571 6.77221C5.39789 6.27119 5.80162 5.86245 6.29949 5.60412C6.79735 5.34579 7.364 5.25102 7.91883 5.33329C8.48478 5.41721 9.00873 5.68093 9.41329 6.08549C9.81785 6.49006 10.0816 7.01401 10.1655 7.57996Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
